import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_FUEL_LEVEL_READING_SUCCESS,
  FETCH_FUEL_LEVEL_READING_SUCCESS,
  GET_FUEL_LEVEL_READING_SUCCESS,
  SAVE_FUEL_LEVEL_READING_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from '../../util/methods';

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_FUEL_LEVEL_READING_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_FUEL_LEVEL_READING_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_FUEL_LEVEL_READING_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_FUEL_LEVEL_READING_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { fuelLevelReading } = store.getState();
      const { query } = fuelLevelReading;
      const response = await axios.get(`/fuel-level-reading?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const documents = payload.documents;
      const formData = new FormData();
      if (Array.isArray(documents) && documents.length) {
        documents.forEach((file) => {
          formData.append('files', file);
        });
      }
      Object.keys(payload).forEach((key) => {
        if (key === 'documents' || payload[key] === undefined || payload[key] === null) {
          return;
        }
        const value = payload[key];
        if (value && typeof value.toISOString === 'function') {
          formData.append(key, value.toISOString());
        } else if (typeof value === 'object') {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const response = await axios.post(`/fuel-level-reading`, formData, config);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
        dispatch(fetchSuccess());
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));
        message.success('Fuel level reading saved');
        history.push('/fuel-level-reading');
        dispatch(getResource());
      }
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to save fuel level reading');
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const documents = payload.documents;
      const formData = new FormData();
      if (Array.isArray(documents) && documents.length) {
        documents.forEach((file) => {
          formData.append('files', file);
        });
      }
      Object.keys(payload).forEach((key) => {
        if (key === 'documents' || payload[key] === undefined || payload[key] === null) {
          return;
        }
        const value = payload[key];
        if (typeof value === 'object') {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const response = await axios.put(`/fuel-level-reading/${id}`, formData, config);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
        dispatch(fetchSuccess());
      } else {
        dispatch(fetchSuccess());
        message.success('Fuel level reading updated');
        history.push('/fuel-level-reading');
        dispatch(getResource());
      }
    } catch (error) {
      const msg = error.response && error.response.data && error.response.data.message;
      message.error(msg || 'Failed to update fuel level reading');
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/fuel-level-reading/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
      console.log("Error****:", error.response && error.response.data && error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.delete(`/fuel-level-reading/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
      console.log("Error****:", error.response && error.response.data && error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { fuelLevelReading } = store.getState();
      const { query } = fuelLevelReading;
      const response = await axios.get(`/fuel-level-reading/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response && error.response.data && error.response.data.message);
      dispatch(fetchError(error.response && error.response.data && error.response.data.message));
    }
  }
};
